import IntlTelInput from './IntlTelInput';

export default IntlTelInput;